export const CATEGORIES = ["wrong", "untranslated", "awkward", "layout", "other"];
export const STATUSES = ["open", "fixed", "wont_fix"];
